import { render, staticRenderFns } from "./RipaFormHeader.vue?vue&type=template&id=277b74c3"
import script from "./RipaFormHeader.vue?vue&type=script&lang=js"
export * from "./RipaFormHeader.vue?vue&type=script&lang=js"
import style0 from "./RipaFormHeader.vue?vue&type=style&index=0&id=277b74c3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports